import * as R from 'ramda';
import React from 'react';
import styled from '@emotion/styled';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { merge } from 'rxjs/observable/merge';
import { flatMap, pluck, takeUntil, tap } from 'rxjs/operators';

import { color, mediaQueries } from 'src/shared/styles/variables';

const ProgressBarWrapper = styled('div')(props => ({
    zIndex: 3,
    display: 'flex',
    marginLeft: props.small ? 0 : '2rem',
    height: '0.75rem',
    width: props.small ? '100%' : '33rem',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [mediaQueries.sm]: {
        width: '100%',
    },
}));

const ProgressBarOuter = styled('div')(props => ({
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    height: ' 100%',
    marginRight: props.small ? '0.75rem' : '1.25rem',
    borderRadius: '1rem',
    backgroundColor: color.silver,
    '& > *': {
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
}));

const ProgressBarInner = styled('div')(
    ({ width }) => ({
        zIndex: 3,
        width: `${width}%`,
        height: '100%',
        borderRadius: '1rem',
        transition: `width .05s ease-in-out`,
    }),
    ({ isColored }) =>
        isColored
            ? {
                  backgroundImage: `linear-gradient(90deg, ${color.robinsEggBlue}, ${color.blueLagoon})`,
              }
            : {
                  backgroundColor: color.white,
              },
);

export class AudioProgressBar extends React.Component {
    componentDidMount() {
        this.mouseUp = fromEvent(this.outer, 'mouseup');
        this.mouseMove = fromEvent(this.outer, 'mousemove');
        this.mouseDown = fromEvent(this.outer, 'mousedown');
        this.mouseLeave = fromEvent(this.outer, 'mouseleave');

        this.mouseDrag = this.mouseDown.pipe(
            pluck('offsetX'),
            tap(this.onMouseDown),
            flatMap(() => this.mouseMove.pipe(pluck('offsetX'), takeUntil(this.mouseUp))),
        );

        merge(this.mouseUp, this.mouseLeave).subscribe(this.props.onMouseUp);
        this.mouseDrag.subscribe(this.onDrag);
    }

    getPercentageFromOffset = offset => (offset / this.outer.clientWidth) * 100;

    onMouseDown = R.pipe(this.getPercentageFromOffset, this.props.onMouseDown);
    onDrag = R.pipe(this.getPercentageFromOffset, this.props.onDrag);

    render() {
        return (
            <ProgressBarWrapper small={this.props.small}>
                <ProgressBarOuter small={this.props.small}>
                    <div ref={outer => (this.outer = outer)}>
                        <ProgressBarInner
                            isColored={this.props.isColored}
                            width={this.props.value.toFixed(2)}
                        />
                    </div>
                </ProgressBarOuter>
            </ProgressBarWrapper>
        );
    }
}
